import React from 'react';
import { StyledFooter, StyledCopyright } from './styled'

export function Footer (props) {
    return (
        <StyledFooter>
            <StyledCopyright>Copyright © 2020 Brian Mello</StyledCopyright>
        </StyledFooter>
    )
}

export default Footer;